import { combineReducers } from 'redux';

import userReducer from './user';
import usersReducer from './users';
import adminsReducer from './admins';
import procesesReducer from './proceses';
import snackbarReducer from './snackbar';
import progressReducer from './progress';
import paychecksReducer from './paychecks';

const rootReducer = combineReducers({
  user: userReducer,
  users: usersReducer,
  admins: adminsReducer,
  proceses: procesesReducer,
  snackbar: snackbarReducer,
  progress: progressReducer,
  paychecks: paychecksReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js